import * as yup from 'yup';
import { inputAmountValidation } from 'util/validation';
import { MIN_INVESTMENT_FIREBLOCKS } from '../../../../util/constants';

export const sumsubQuoteValidation = yup.object().shape({
  amount: inputAmountValidation({
    coin: 'USDT',
    min: MIN_INVESTMENT_FIREBLOCKS,
    maxDecimals: 2,
  }),
  currency: yup.string().required('common:required'),
  method: yup.string().required('common:required'),
});
